import React from 'react'
import { SlideOutNavItem } from './SlideOutNavItem'
import { featureFlagService } from 'utils/featureFlagService'

export const WorkspaceSlideOutContent: React.FC = () => {
  const { enableNewNavigation } = featureFlagService()

  const items = [
    { label: 'Documents', path: '/documents' },
    { label: 'Contacts', path: '/contacts' },
    { label: 'Activity', path: '/activity' },
    {
      label: 'Products',
      path: enableNewNavigation ? '/products' : '/settings/platform/products',
    },
  ]

  return (
    <ul className="list-none m-0 p-0 flex flex-col gap-1.5">
      {items.map((item) => (
        <SlideOutNavItem
          key={item.path}
          label={item.label}
          path={item.path}
          section="workspace"
        />
      ))}
    </ul>
  )
}
